<template lang="html">
  <div>
    <Layout currentMenu="Vendor Registration">
      <LoadingSection
        title="Vendor Registration"
        :loading="loading"
        :autoPadding="false"
      >
        <template v-slot:content>
          <div class="section-field flex-box wrap vendor-data" v-if="vendor">
            <h3 class="black pull-left bgap-24">Organization Details</h3>
            <div class="right pull-right">
              <div>Name: {{ vendor.organization.name }}</div>
              <div class="gap-3x" />
              <div>Admin Email: {{ vendor.organization.admin_email }}</div>
              <div class="gap-3x" />
              <div>Admin Name: {{ vendor.organization.admin_name }}</div>
              <div class="gap-3x" />
              <div>Type: {{ vendor.data.type }}</div>
              <div class="gap-3x" />
              <div>
                URL:
                <a
                  target="blank"
                  :href="vendor.data.primaryURL"
                  class="link active"
                  >{{ vendor.data.primaryURL }}</a
                >
              </div>
              <div class="gap-3x" />
              <div>
                Article URL:
                <a
                  target="blank"
                  :href="vendor.data.articleURL"
                  class="link active"
                  >{{ vendor.data.articleURL }}</a
                >
              </div>
              <div class="gap-3x" />
              <div>
                List of Project URL:
                <a
                  target="blank"
                  :href="vendor.data.listOfProjectURL"
                  class="link active"
                  >{{ vendor.data.listOfProjectURL }}</a
                >
              </div>
              <div class="gap-3x" />
              <div>
                License State: {{ vendor.data.professionalLicenseState}}
              </div>
              <div class="gap-3x" />
              <div>
                License Number: {{ vendor.data.professionalLicenseNumber }}
              </div>
              <div class="gap-3x" />
              <div>
                Expiration Date:
                {{ vendor.data.professionalLicenseExpirationDate }}
              </div>
              <div class="gap-3x" />
              <div>Status: {{ vendor.status }}</div>
            </div>
          </div>
          <div class="section-field flex-box wrap">
            <h3 class="black pull-left bgap-24">Submitted by</h3>
            <div class="right pull-right">
              <div>Email Address: {{ vendor.user.email }}</div>
              <div class="gap-3x" />
              <div>Name: {{ vendor.user.name }}</div>
              <div class="gap-3x" />
              <div>Phone: {{ vendor.user.phone }}</div>
              <div class="gap-3x" />
              <div>Created at: {{formatDate(vendor.created_at)}}</div>
            </div>
          </div>
          <div class="gap-3x" />
          <div class="flex-box footer-section wrap" v-if="!viewOnly">
            <SymbiumButton
              text="Back To List"
              :onClick="backToList"
              :loading="loading"
              :isPrimary="true"
              :isSmall="true"
            />

            <SymbiumButton
              text="Delete"
              :onClick="deleteVendorRegistration"
              :loading="loading"
              :isPrimary="true"
              :isSmall="true"
            />

            <SymbiumButton
              text="Approve"
              :onClick="approve"
              :loading="loading"
              :isSmall="true"
            />
          </div>
        </template>
      </LoadingSection>
    </Layout>
    <ConfirmModal />
  </div>
</template>

<script>
import ConfirmModal from 'src/components/common/modals/ConfirmModal.vue'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import moment from "moment";
// import EventBus from 'src/components/EventBus.js'
// import _ from 'lodash';

export default {
  components: {
    SymbiumButton,
    ConfirmModal,
    LoadingSection,
    Layout,
  },
  data() {
    return {
      vendor: null,
      loading: false,
      viewOnly: false,
    }
  },
  methods: {
    backToList() {
      this.$router.push('/dashboard/vendors')
    },
    refetchData() {
      this.loading = true
      this.$vendor.fetchVendorRegistration(this.$route.query.id, this.assignData)
    },
    formatDate(date) {
      return date ? moment(date).format('LLL') : '';
    },
    deleteVendorRegistration() {
      this.$modal.show('confirm-modal', {
        actionText: 'Delete',
        cancelText: 'Cancel',
        confirmMessage: "Are you sure to delete this vendor's registration?",
        confirmCallBack: this.sendDeleteRequest,
        alert: false,
      })
    },
    sendDeleteRequest() {
      this.$modal.hide('confirm-modal')
      this.loading = true
      this.$vendor.deleteVendorRegistration(
        this.$route.query.id,
        this.backToList
      )
    },
    approve() {
      this.$modal.show('confirm-modal', {
        actionText: 'Approve',
        cancelText: 'Cancel',
        confirmMessage: 'Are you sure to approve this vendor?',
        confirmCallBack: this.sendApproveRequest,
        alert: false,
      })
    },
    sendApproveRequest() {
      this.$modal.hide('confirm-modal')
      this.loading = true
      this.$vendor.updateVendorRegistration(
        this.$route.query.id,
        { status: 'active' },
        this.refetchData
      )
    },
    assignData(response) {
      this.loading = false
      this.vendor = response.data
    },
  },
  mounted() {
    this.loading = true
    this.viewOnly = this.$route.query.view_only == 'true'
    this.$user.fetchMe()
    this.$vendor.fetchVendorRegistration(this.$route.query.id, this.assignData)
  },
}
</script>

<style lang="scss">
.footer-section {
  margin-top: -24px;
  .btn-base {
    margin-right: 24px;
    margin-top: 24px;
  }
}
</style>
